import React from 'react';
import { Segment, SearchBox, Switch } from 'tea-component';
import './index.scss';

interface ReportToolbarProps {
  /** Tab选项 */
  tabOptions: Array<{ value: string; text: string; }>;
  /** 当前选中的tab值 */
  segmentValue: string | number;
  /** Tab切换回调 */
  onSegmentChange: (value: string) => void;
  /** 搜索关键词 */
  searchValue: string;
  /** 搜索变化回调 */
  onSearchChange: (value: string) => void;
  /** 搜索回调 */
  onSearch: (keyword?: string, context?: any) => void;
  /** 清空搜索回调 */
  onClearSearch: () => void;
  /** 搜索框占位符 */
  searchPlaceholder: string;
  showEditorNotesToggle?: boolean;
  editorNotesEnabled?: boolean;
  onEditorNotesToggle?: (checked: boolean) => void;
  editorNotesLabel?: string;
}

/**
 * 报告工具栏组件
 * 包含 Tab 切换和搜索功能
 */
const ReportToolbar: React.FC<ReportToolbarProps> = ({
  tabOptions,
  segmentValue,
  onSegmentChange,
  searchValue,
  onSearchChange,
  onSearch,
  onClearSearch,
  searchPlaceholder,
  showEditorNotesToggle = false,
  editorNotesEnabled = true,
  onEditorNotesToggle,
  editorNotesLabel = "View Editor's notes",
}) => {
  const showTabs = tabOptions.length > 1;

  return (
    <div className="dbh-report-toolbar">
      <div className="dbh-report-toolbar__left">
        {showTabs && (
          <Segment
            options={tabOptions}
            value={String(segmentValue)}
            onChange={onSegmentChange}
          />
        )}
        {showEditorNotesToggle && (
          <label className="dbh-report-toolbar-toggle">
            <Switch
              value={editorNotesEnabled}
              onChange={(val) => onEditorNotesToggle?.(val)}
            />
            <span className="dbh-report-toolbar-toggle__label">{editorNotesLabel}</span>
          </label>
        )}
      </div>
      <SearchBox
        value={searchValue}
        className="dbh-report-toolbar-search"
        onChange={onSearchChange}
        onSearch={onSearch}
        onClear={onClearSearch}
        placeholder={searchPlaceholder}
      />
    </div>
  );
};

export default ReportToolbar;
